<template>
  <div>
    <div
      id="payment-request-button"
      class="pt-2 mb-2"
      :class="disabled ? 'disabled' : 'enabled'"
    ></div>
    <div
      v-if="enableCustomButton"
      class="gpay-custom-button"
      @click="clickCustomGPay"
    >
      <img src="../../../../assets/Google_Pay_Logo.svg" />
    </div>
    <div style="color: red">{{ error }}</div>
  </div>
</template>

<script>
import { StripePay } from "../../../../api/payment/stripePay";
import { mapGetters } from "vuex";
import { AppConfig } from "./../../../../../AppConfig.js";
// import { $$ } from "./../../../../sharedscripts/OO_jquery";
import { logger } from "../../../../api/Logger";
import { DetectMobile } from "../../../../mixins/detectmobile";

const stripeToken = AppConfig.stripeToken;
export default {
  data() {
    return {
      showGooglePayBtn: false,
      error: "",
      refernceId: 0,
      stripe: null,
      paymentRequest: null,
      trackingOrder: null,
      applePay: false,
      tokenId: null,
      enableCustomButton: false,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["getTotalPrice", "selectedCompany"]),
  },
  async mounted() {
    // eslint-disable-next-line no-undef
    this.stripe = Stripe(stripeToken);
    this.paymentRequest = this.stripe.paymentRequest({
      country: "AU",
      currency: "aud",
      total: {
        label: this.selectedCompany.Name,
        amount: parseInt(this.getTotalPrice * 100, 10), // total in cent
      },
      requestPayerName: false,
      requestPayerEmail: false,
    });

    var elements = this.stripe.elements();
    var that = this;
    var prButton = elements.create("paymentRequestButton", {
      paymentRequest: that.paymentRequest,
    });

    // Check the availability of the Payment Request API first.
    this.paymentRequest.canMakePayment().then(function (result) {
      if (result) {
        if (!DetectMobile.methods.isMobile() && !result.applePay) {
          that.enableCustomButton = true;
        } else {
          prButton.mount("#payment-request-button");
        }
        // that.validate();
        that.applePay = !!result.applePay;
        logger.log(
          "Initial stripe pay button",
          `${
            result.applePay ? "Apple" : "Google"
          } pay button initial successful`,
          "GooglePay.vue",
          logger.LogType.Info
        );
      } else {
        if (document.getElementById("payment-request-button") != null)
          document.getElementById("payment-request-button").style.display =
            "none";
        logger.log(
          "Initial stripe pay button",
          "Pay button initialize failed browser do not support or payment method not added",
          "GooglePay.vue",
          logger.LogType.Warning
        );
      }
    });
    prButton.on("click", (event) => {
      event.preventDefault();
      this.$emit("stripe-click", this.applePay ? 6 : 7);
      setTimeout(() => {
        that.validate();
      }, 100);
    });

    // if (!this.disabled) {
    //   $$("#payment-request-button").attr("class", "enabled");
    // } else {
    //   $$("#payment-request-button").attr("class", "disabled");
    // }
    this.beginPayment();
  },
  methods: {
    validate() {
      this.$emit("validate");
    },
    setTrackingOrder(trackingOrder) {
      this.trackingOrder = trackingOrder;
    },
    async finalizeAsync(trackingOrder) {
      this.$emit("finalize", trackingOrder);
    },
    paymentMethod(ev) {
      var stripePay = new StripePay({});
      var that = this;
      this.$emit("proccessing", true);
      that.trackingOrder.TrackingOrder.PaymentTransactions[0].RenfrenceNumber =
        that.tokenId;
      logger.log(
        "Payment start",
        `Payment with ${
          that.applePay ? "Apple" : "Google"
        }Pay start => ${JSON.stringify(that.trackingOrder)}`,
        "GooglePay.vue",
        logger.LogType.Info
      );

      stripePay.createOrder(that.trackingOrder).then((customerInfo) => {
        if (customerInfo.data.Success) {
          logger.log(
            "Order Created successful",
            `Order created succesful for payment by ${
              that.applePay ? "Apple" : "Google"
            }Pay with response => ${JSON.stringify(customerInfo)}`,
            "GooglePay.vue",
            logger.LogType.Info
          );
          stripePay
            .createPayment(that.trackingOrder.TrackingOrder)
            .then((stripeDate) => {
              if (stripeDate.data.Success) {
                logger.log(
                  "Payment Created successful",
                  `Payment created succesful for payment by ${
                    that.applePay ? "Apple" : "Google"
                  }Pay with response => ${JSON.stringify(stripeDate)}`,
                  "GooglePay.vue",
                  logger.LogType.Info
                );
                // Confirm the PaymentIntent without handling potential next actions (yet).
                that.stripe
                  .confirmCardPayment(
                    stripeDate.data.ClientSecret,
                    { payment_method: ev.paymentMethod.id },
                    { handleActions: false }
                  )
                  .then(function (confirmResult) {
                    if (confirmResult.error) {
                      logger.log(
                        "Confirm Stripe card payment failed",
                        `Confirm Stripe card payment failed for payment by ${
                          that.applePay ? "Apple" : "Google"
                        }Pay with response => ${JSON.stringify(confirmResult)}`,
                        "GooglePay.vue",
                        logger.LogType.Error
                      );
                      // Report to the browser that the payment failed, prompting it to
                      // re-show the payment interface, or show an error message and close
                      // the payment interface.
                      that.$emit("error", confirmResult.error.message);
                      that.$emit("proccessing", false);
                      ev.complete("fail");
                    } else {
                      // Report to the browser that the confirmation was successful, prompting
                      // it to close the browser payment method collection interface.
                      ev.complete("success");
                      logger.log(
                        "Confirm Stripe card payment successful",
                        `Confirm Stripe card payment succesful for payment by ${
                          that.applePay ? "Apple" : "Google"
                        }Pay with response => ${JSON.stringify(confirmResult)}`,
                        "GooglePay.vue",
                        logger.LogType.Info
                      );
                      // The payment has succeeded.
                      that.finalizeAsync(that.trackingOrder);
                      // Let Stripe.js handle the rest of the payment flow.
                      if (
                        confirmResult.paymentIntent &&
                        confirmResult.paymentIntent.status === "requires_action"
                      ) {
                        that.stripe
                          .confirmCardPayment(stripeDate.data.ClientSecret)
                          .then(function (result) {
                            if (result.error) {
                              logger.log(
                                "Confirm Stripe card payment failed for requires action status",
                                `Confirm Stripe card payment failed for requires action status for payment by ${
                                  that.applePay ? "Apple" : "Google"
                                }Pay with response => ${JSON.stringify(
                                  result
                                )}`,
                                "GooglePay.vue",
                                logger.LogType.Error
                              );
                              that.$emit("proccessing", false);
                              that.$emit("error", result.error.message);
                              // The payment failed -- ask your customer for a new payment method.
                            } else {
                              logger.log(
                                "Confirm Stripe card payment successful for requires action status",
                                `Confirm Stripe card payment succesful for requires action status for payment by ${
                                  that.applePay ? "Apple" : "Google"
                                }Pay with response => ${JSON.stringify(
                                  result
                                )}`,
                                "GooglePay.vue",
                                logger.LogType.Info
                              );
                              // Report to the browser that the confirmation was successful, prompting
                              // it to close the browser payment method collection interface.
                              ev.complete("success");
                              // The payment has succeeded.
                              that.$emit("finalize", that.trackingOrder);
                            }
                          });
                      }
                    }
                  });
              } else {
                logger.log(
                  "Payment Created failed",
                  `Payment created failed for payment by ${
                    that.applePay ? "Apple" : "Google"
                  }Pay with response => ${JSON.stringify(stripeDate)}`,
                  "GooglePay.vue",
                  logger.LogType.Error
                );
                that.$emit(
                  "error",
                  stripeDate.errMessage && stripeDate.errMessage.Message
                    ? stripeDate.errMessage.Message
                    : "Could not create a payment please try again"
                );
                that.$emit("proccessing", false);
                ev.complete("fail");
              }
            });
        } else {
          logger.log(
            "Order Created failed",
            `Order created failed for payment by ${
              that.applePay ? "Apple" : "Google"
            }Pay with response => ${JSON.stringify(customerInfo)}`,
            "GooglePay.vue",
            logger.LogType.Error
          );
          that.$emit(
            "error",
            customerInfo.errMessage && customerInfo.errMessage.Message
              ? customerInfo.errMessage.Message
              : "Could not create an order please try again"
          );
          that.$emit("proccessing", false);
          ev.complete("fail");
        }
      });
    },
    beginPayment() {
      var that = this;
      //this.$emit("stripe-click", this.applePay ? 6 : 7);

      this.$nextTick(() => {
        this.paymentRequest.removeAllListeners();
        this.paymentRequest.on("token", function (event) {
          that.tokenId = event.token ? event.token.id : null;
        });
        this.paymentRequest.on("cancel", function () {
          // handle cancel event
          that.$emit("proccessing", false);
        });
        this.paymentRequest.on("paymentmethod", this.paymentMethod);
      });
    },
    showPayment() {
      if (!this.disabled) {
        this.paymentRequest.show();
      }
    },
    clickCustomGPay() {
      this.$emit("stripe-click", this.applePay ? 6 : 7);
      var that = this;
      setTimeout(() => {
        that.validate();
      }, 100);
    },
  },
  watch: {
    disabled() {
      if (!this.disabled && !this.trackingOrder) {
        this.beginPayment();
      }
    },
  },
};
</script>

<style>
.disabled {
  pointer-events: none;
  opacity: 0.4;
}
.enabled {
  opacity: 1;
}
</style>
